import React from "react";
import Hero from "../components/aboutus/Hero";
import Personnel from "../components/aboutus/Personnel";
import Record from "../components/aboutus/Record";
import Team from "../components/aboutus/Team";
import PreFooter from "../components/PreFooter";

function Aboutus() {
  return (
    <>
      <Hero />
      <Personnel />
      <Team />
      <Record />
      <PreFooter />
    </>
  );
}

export default Aboutus;
